import { Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { texts } from "../../../../../general/texts";

const SearchFields = ({
  searchMethods,
  state,
  handleTextFieldChange,
  classes,
}) => {
  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      rowGap={1}
      marginTop={2}
    >
      <Grid container item md={12} xs={12}>
        <Typography className={classes.fieldTitle}>
          {searchMethods === "Individ" ? "Numër ID" : "NIPT"}
        </Typography>
      </Grid>
      <Grid container item md={12} xs={12}>
        <TextField
          size="small"
          color="warning"
          onChange={handleTextFieldChange("nuis")}
          value={state.nuis}
          className={classes.textField}
        />
      </Grid>
      <Grid container item md={12} xs={12}>
        <Typography className={classes.fieldTitle}>
          {searchMethods === "Individ"
            ? "Emër Mbiemër i Individit"
            : "Subjekti (Emër i plotë)"}
        </Typography>
      </Grid>
      <Grid container item md={12} xs={12}>
        <TextField
          size="small"
          color="warning"
          onChange={handleTextFieldChange("subject")}
          value={state.subject}
          className={classes.textField}
        />
      </Grid>
      <Grid container item md={12} xs={12}>
        <Typography className={classes.fieldTitle}>{texts["prompt-invoice-number"]}</Typography>
      </Grid>
      <Grid container item md={12} xs={12}>
        <TextField
          size="small"
          color="warning"
          onChange={handleTextFieldChange("serial")}
          value={state.serial}
          className={classes.textField}
        />
      </Grid>
    </Grid>
  );
};

export default SearchFields;
